import {SubAPI} from "./SubAPI";

export class Debug extends SubAPI {
    submit(input: {
        file: File;
        browserUrl: string;
    }) {
        return this.fetcher.postFormData<{customerId: string}>("/api/debug/submit-log", input)
    }
}